import { Clock, ArrowUpRight } from "lucide-react";

function formatDuration(m) {
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem ? `${h}h ${rem}m` : `${h}h`;
}

export default function Services({ services = [], onBook }) {
  const bookable = services.filter((s) => !s.is_addon);
  const addon = services.find((s) => s.is_addon);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-stone-900 bg-stone-950"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-amber-500/80 mb-4">
              The Menu
            </div>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight text-stone-50 leading-tight max-w-xl">
              Straightforward services.
              <br />
              <span className="italic text-amber-500">Honest</span> pricing.
            </h2>
          </div>
          <p className="text-stone-400 max-w-md text-base leading-relaxed">
            Pay in shop after your service. Card, cash or e-transfer — up to
            you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {bookable.map((s, idx) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`group relative overflow-hidden border border-stone-800 bg-stone-900 min-h-[380px] flex flex-col justify-end ${
                idx === 0 ? "md:col-span-7" : "md:col-span-5"
              }`}
            >
              <img
                src={s.image}
                alt={s.name}
                className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-stone-950/70 to-stone-950/20" />
              <div className="relative z-10 p-8 md:p-10">
                <div className="flex items-baseline justify-between gap-6">
                  <h3 className="font-display text-3xl md:text-4xl tracking-tight text-stone-50">
                    {s.name}
                  </h3>
                  <div className="font-display text-3xl md:text-4xl text-amber-500">
                    ${s.price}
                  </div>
                </div>
                <div className="mt-4 flex items-center gap-2 text-stone-400 text-sm">
                  <Clock size={14} className="text-amber-500/80" />
                  <span>{formatDuration(s.duration_min)}</span>
                </div>
                <p className="mt-5 text-stone-300 text-sm md:text-base leading-relaxed max-w-lg">
                  {s.description}
                </p>
                <button
                  data-testid={`book-service-${s.id}`}
                  onClick={() => onBook(s.id)}
                  className="mt-8 inline-flex items-center gap-2 bg-amber-500 text-stone-950 px-6 py-3 text-xs tracking-[0.2em] uppercase font-medium hover:bg-amber-400 transition-colors duration-300"
                >
                  Book {s.name}
                  <ArrowUpRight size={14} />
                </button>
              </div>
            </article>
          ))}

          {/* Add-on strip */}
          {addon && (
            <div
              data-testid={`service-card-${addon.id}`}
              className="md:col-span-12 border border-stone-800 bg-stone-900/60 backdrop-blur-sm p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 justify-between"
            >
              <div className="flex-1">
                <div className="text-[10px] tracking-[0.3em] uppercase text-amber-500/80 mb-2">
                  Add-on
                </div>
                <h3 className="font-display text-2xl md:text-3xl text-stone-50">
                  {addon.name}
                </h3>
                <p className="mt-3 text-stone-400 text-sm md:text-base leading-relaxed max-w-xl">
                  {addon.description.replace("Add-on to Regular Haircut. ", "")}
                  {" "}Available with any cut.
                </p>
              </div>
              <div className="flex flex-col md:items-end gap-3">
                <div className="flex items-center gap-4">
                  <div className="font-display text-2xl text-amber-500">
                    +${addon.price}
                  </div>
                  <div className="text-stone-500 text-sm flex items-center gap-1">
                    <Clock size={13} /> +{formatDuration(addon.duration_min)}
                  </div>
                </div>
                <button
                  data-testid="book-with-addon"
                  onClick={() => onBook("regular-haircut", true)}
                  className="border border-amber-500/60 text-amber-500 px-6 py-3 text-xs tracking-[0.2em] uppercase hover:bg-amber-500/10 transition-colors duration-300"
                >
                  Add to Haircut
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
